import { DefaultControl } from '../types';

const inlineControls: DefaultControl[] = [
    { label: 'Bold', style: 'BOLD', icon: 'bold' },
    { label: 'Italic', style: 'ITALIC', icon: 'italic' },
    { label: 'Underline', style: 'UNDERLINE', icon: 'underline' },
];

export default inlineControls;
